import * as _4 from 'lodash';
const commonPref = (
  scope: ng.IScope,
  prefsObj: { type: string },
  type: 'busy_time' | 'campus_location' | 'commitment'
) => {
  if (!_4.isEmpty(prefsObj)) {
    prefsObj.type = type;
    scope.setPreferenceValue(prefsObj);
  }
};
angular
  .module('capability-ng-scheduler')
  .controller(
    'preferencesSummaryController',
    (
      $scope: angular.IScope,
      $rootScope: any,
      preferencesSummarySvc: any,
      preferencesBusyTimes: any,
      PreferenceTypeEnum: any
    ) => {
      $scope.models = {
        preferenceValue: 0,
        preferenceTypeUnit: PreferenceTypeEnum[$scope.type.toUpperCase()].value.unit,
        sum: 0,
        isUpdated: false
      };

      $scope.preferenceTypeEnum = PreferenceTypeEnum;

      $scope.setPreferenceValue = (prefsObj: any) => {
        if (_4.isEqual(prefsObj.type, $scope.type)) {
          $scope.models.preferenceValue = preferencesSummarySvc.update(prefsObj);
          $scope.models.isUpdated = $scope.models.preferenceValue > 0 || $scope.models.preferenceValue === `All`;
        }
      };

      preferencesBusyTimes.getSummary();
    }
  )
  .constant('preferencesSummaryDelegateConfiguration', {
    uniqueComponent: 'preferencesSummary',
    vocabulary: {
      setCommitment(
        this: any,
        scope: ng.IScope,
        element: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        event: any,
        prefsObj: { type: string }
      ) {
        commonPref(scope, prefsObj, 'commitment');
      },
      setCampusLocation(
        this: any,
        scope: ng.IScope,
        element: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        event: any,
        prefsObj: { type: string }
      ) {
        commonPref(scope, prefsObj, 'campus_location');
      },
      setBusyTime(
        this: any,
        scope: ng.IScope,
        element: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        event: any,
        prefsObj: { type: string }
      ) {
        commonPref(scope, prefsObj, 'busy_time');
      }
    }
  })
  .directive(
    'preferencesSummary',
    function preferencesSummary(DelegateResponder: any, preferencesSummaryDelegateConfiguration: any) {
      return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'capability-ng-scheduler/src/views/components/preferences_summary/preferences_summary.html',
        controller: 'preferencesSummaryController',
        scope: {
          type: '@',
          mode: '@'
        },
        link: DelegateResponder(
          preferencesSummaryDelegateConfiguration,
          (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
            scope.models.preferenceValue = 0;
          }
        )
      };
    }
  )
  .service(
    'preferencesSummaryDelegate',
    function preferencesSummaryDelegate(
      this: any,
      DelegateController: any,
      preferencesSummaryDelegateConfiguration: any
    ) {
      DelegateController(this, preferencesSummaryDelegateConfiguration);
    }
  )
  .factory('preferencesSummarySvc', (CommitmentRangesEnum: any) => {
    const summary: any = {
      commitmentRanges: {},
      commitmentRangesSum: 0,
      campusesQuantity: 0
    };

    const getSummaryValue = {
      commitment: (prefsObj: any) => {
        if (_4.isEmpty(summary.commitmentRanges)) {
          _4.each(CommitmentRangesEnum, (range: any) => {
            summary.commitmentRanges[range.id] = 0;
          });
        }

        summary.commitmentRanges[prefsObj.id] = parseInt(prefsObj.value, 10);
        return (summary.commitmentRangesSum = _4.reduce(
          summary.commitmentRanges,
          (sum: any, value: any) => {
            return sum + value;
          },
          0
        ));
      },
      campus_location: (prefsObj: any) => {
        if (prefsObj.campuses) {
          const selectedCampuses = _4.filter(prefsObj.campuses, (campus: any) => campus._selected && !campus.is_global);
          return prefsObj.campuses.length === selectedCampuses.length ? 'All' : selectedCampuses.length;
        } else {
          return 0;
        }
      },
      busy_time: (prefsObj: any) => {
        return !_4.isUndefined(prefsObj.busyTimes) ? prefsObj.busyTimes.length : 0;
      }
    };

    summary.update = (prefsObj: any) => getSummaryValue[prefsObj.type](prefsObj);

    return summary;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences_summary/preferences_summary.ts